import { memo, useMemo } from 'react';
import { Box, Skeleton } from '@betty/moonlight';
import { groupByRows } from './Amounts.utils';

function AmountsSkeleton() {
  const rows = useMemo(() => groupByRows(Array.from({ length: 6 })), []);

  return (
    <Box gap="space-600">
      <Skeleton height={21.6} />
      <Box gap="space-300">
        {rows.map((amounts, index) => (
          <Box key={index} flexDirection="row" gap="space-300">
            {amounts.map((_, index) => (
              <Skeleton
                key={index}
                height="space-1400"
                borderRadius="radius-200"
                flexGrow={1}
                flexShrink={1}
                flexBasis={80}
              />
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default memo(AmountsSkeleton);
